/**
 * ReproducibilityPanel — reproducibility report findings.
 *
 * Shows findings like hardcoded values, missing VCS metadata,
 * broken provenance chains, and an overall reproducibility score.
 */

import { useQuery } from "@tanstack/react-query";
import { Box, Heading, Text } from "@radix-ui/themes";
import { apiClient } from "../../api/client";

interface Props {
  projectId: string;
}

export default function ReproducibilityPanel({ projectId }: Props) {
  const { data, isLoading } = useQuery({
    queryKey: ["reproducibility", projectId],
    queryFn: () =>
      apiClient<{ findings: unknown[]; score: number | null }>(
        `/reproducibility/${projectId}`,
      ),
  });

  return (
    <Box p="3" style={{ height: "100%", overflow: "auto" }}>
      <Heading size="4" mb="3">
        Reproducibility Report
      </Heading>

      {isLoading && <Text color="gray">Analysing...</Text>}

      {data?.score !== null && data?.score !== undefined && (
        <Text size="5" weight="bold" mb="3">
          Score: {data.score}/100
        </Text>
      )}

      {data?.findings.length === 0 && (
        <Text color="gray">No findings yet.</Text>
      )}

      {/* TODO: Render findings list by severity */}
    </Box>
  );
}
